import React, { useState, useEffect } from 'react'
import { Upload, Modal, message } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { Spinner } from 'reactstrap'

import { deleteMedia, storeMedia } from './services'
import { handleError } from '../../helpers'

export default function ModelMediasWidget({ model, modelType, reload }) {
	const [previewVisible, setPreviewVisible] = useState(false)
	const [previewImage, setPreviewImage] = useState('')
	const [fileList, setFileList] = useState(null)
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		let newList = model.medias.map( media => ({
			uid: media.id,
			status: 'done',
			url: media.url,
		}))
		setFileList(newList)
	}, [ model ])

	if(!fileList) return <Spinner size="small" />
 
	const handlePreview = async file => {
		setPreviewImage(file.url || file.preview)
		setPreviewVisible(true)
	}

	const handleDelete = file => {
		deleteMedia(file.uid)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const props = {
		fileList,
		listType: 'picture-card',
		onPreview: handlePreview,
		onRemove: handleDelete,
		customRequest: async ({
			file,
			onError,
			onSuccess,
		}) => {
		  	let fileExt = file.name.split('.').pop();
			let filePath = `app/medias/${modelType}/${model.id}/${new Date().getTime()}.${fileExt}`
		
			const values = new FormData()
			values.append('file', file)
			values.append('file_path', filePath)
			values.append('attachable_type', modelType)
			values.append('attachable_id', model.id)

			setLoading(true)

			try {
                const response = await storeMedia(values)
                onSuccess(response.data, file)
                message.success(response.data.message)
                reload()
            } catch (error) {
                onError(error)
                handleError(error)
            }

			setLoading(false)
		}
	}

   return (
      <React.Fragment>
        	<Upload {...props} disabled={loading}>
          	{fileList.length <= 5 && (
					<div>
						{!loading ? <PlusOutlined /> : <Spinner size="small" />} 
						<div className='mt-2'>Upload</div>
					</div>
				)}
        	</Upload>
        	<Modal
				visible={previewVisible}
				title="Vista Previa"
				footer={null}
				onCancel={() => setPreviewVisible(false)}
        	>
          	<img alt="vista_previa" style={{ width: '100%' }} src={previewImage} />
        	</Modal>
      </React.Fragment>
   );
}